/* eslint-disable ember/no-computed-properties-in-native-classes */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import DataType from '@linc-technologies/linced-common/enums/data-type';
import { filterValue } from '@linc-technologies/linced-common/utils/filtering';

export default class CaregiverUserAccountsController extends Controller {
  @action
  setContactFilter(value) {
    this.contactFilter = value;
  }

  @action
  setFirstNameFilter(value) {
    this.firstNameFilter = value;
  }

  @action
  setHomeroomFilter(value) {
    this.homeroomFilter = value;
  }

  @action
  setLastNameFilter(value) {
    this.lastNameFilter = value;
  }

  @tracked
  contactFilter;

  @tracked
  firstNameFilter;

  @tracked
  homeroomFilter;

  @tracked
  lastNameFilter;

  @computed(
    'model.learners.[]',
    'lastNameFilter',
    'firstNameFilter',
    'homeroomFilter',
    'contactFilter',
  )
  get filteredLearners() {
    let learners = this.model.learners;

    let filterLastName = !isEmpty(this.lastNameFilter);
    let filterFirstName = !isEmpty(this.firstNameFilter);
    let filterHomeroom = !isEmpty(this.homeroomFilter);
    let filterContacts = !isEmpty(this.contactFilter);
    if (filterLastName || filterFirstName || filterHomeroom || filterContacts) {
      learners = learners.filter((person) => {
        if (filterLastName) {
          let fieldValue = person.get('lastName') ?? '';
          if (!filterValue(fieldValue, DataType.STRING, this.lastNameFilter)) {
            return false;
          }
        }
        if (filterFirstName) {
          let fieldValue = person.get('firstName') ?? '';
          if (!filterValue(fieldValue, DataType.STRING, this.firstNameFilter)) {
            return false;
          }
        }
        if (filterHomeroom) {
          let fieldValue = person.get('homeroom.name') ?? '';
          if (!filterValue(fieldValue, DataType.STRING, this.homeroomFilter)) {
            return false;
          }
        }
        if (filterContacts) {
          if (this.contactFilter.trim() === '!*') {
            // Filter for learners with no contacts.
            return person.get('learner.contacts').every((contact) => {
              // Those who don't have access or don't have user accounts don't count.
              return (
                !contact.allowedAccess ||
                isEmpty(contact.get('caregiver.userId'))
              );
            });
          }

          return person.get('learner.contacts').any((contact) => {
            if (
              !contact.allowedAccess ||
              isEmpty(contact.get('caregiver.userId'))
            ) {
              // Not allowed access, or no user account - skip.
              return false;
            }

            // Include this learner if any contact's name matches the filter.
            let contactName = contact.get('fullName');
            return filterValue(
              contactName,
              DataType.STRING,
              this.contactFilter,
            );
          });
        }

        // Matched all specified filters - include this record.
        return true;
      });
    }

    return learners;
  }
}
